module.exports = __webpack_public_path__ + "static/media/849CameronMadisonAlexanderBlvdNW_2018-07-09_199.6ddd76dc.jpg";